import React, { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { FORM_COLORS } from '../constants';

export type InfoBoxTone = 'amber' | 'pink' | 'gray' | 'green' | 'blue';

const TONE_STYLES: Record<InfoBoxTone, { bg: string; border: string; color: string }> = {
  amber: { bg: FORM_COLORS.amberBg, border: FORM_COLORS.amberBorder, color: '#633806' },
  pink: { bg: FORM_COLORS.pinkLight, border: FORM_COLORS.pinkMedium, color: FORM_COLORS.pinkDark },
  gray: { bg: FORM_COLORS.bg, border: FORM_COLORS.border, color: FORM_COLORS.textSecondary },
  green: { bg: FORM_COLORS.greenBg, border: FORM_COLORS.greenBorder, color: FORM_COLORS.green },
  blue: { bg: FORM_COLORS.blueBg, border: FORM_COLORS.blueBorder, color: FORM_COLORS.blue },
};

const useStyles = makeStyles(() => ({
  box: {
    borderRadius: 8,
    padding: '10px 14px',
    marginBottom: 14,
    fontSize: 13,
    display: 'flex',
    gap: 8,
    alignItems: 'flex-start',
    border: '0.5px solid',
    lineHeight: 1.45,
  },
  icon: {
    fontSize: 18,
    flexShrink: 0,
    marginTop: 1,
  },
}));

interface InfoBoxProps {
  tone?: InfoBoxTone;
  children: ReactNode;
}

export const InfoBox = ({ tone = 'gray', children }: InfoBoxProps) => {
  const classes = useStyles();
  const palette = TONE_STYLES[tone];
  const Icon =
    tone === 'amber' ? WarningRoundedIcon : tone === 'green' ? CheckCircleOutlineIcon : InfoOutlinedIcon;

  return (
    <div
      className={classes.box}
      style={{ background: palette.bg, borderColor: palette.border, color: palette.color }}
    >
      <Icon className={classes.icon} style={{ color: palette.color }} />
      <span>{children}</span>
    </div>
  );
};
